import React from 'react'
import { makeStyles } from '@material-ui/core'
import IconButton from '@mui/material/IconButton'
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft'
import ArrowRightIcon from '@mui/icons-material/ArrowRight'

const HMapLeftPanelMinimizer = ({ toggle, setToggle }) => {
  const classes = useStyles()

  const toggleHandler = () => setToggle((prev) => !prev)

  return (
    <div className={classes.root} onClick={toggleHandler}>
      <IconButton
        aria-label="expand row"
        size="small"
        className={classes.arrowIcon}
      >
        {!toggle ? (
          <ArrowRightIcon className={classes.arrowIcon} />
        ) : (
          <ArrowLeftIcon className={classes.arrowIcon} />
        )}
      </IconButton>
    </div>
  )
}

export default React.memo(HMapLeftPanelMinimizer)

const useStyles = makeStyles((theme) => ({
  root: {
    width: '10px',
    height: '100%',
    borderRadius: '0 5px 5px 0',
    backgroundColor: theme.palette.quaternary.accent,
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  arrowIcon: {
    color: theme.palette.primary.main
  }
}))
